<!--每日缺陷-->
<template>
  <div v-if="dataNotNull" key="1" class="defectDiv" style="width: 100%; height: 100%">
    <div class="container1" style="margin:15px 0 0 20px; height: 100%;"></div>
  </div>
  <div v-else key="2" style="width: 100%; height: 100%;">
    <div class="title_defect">Defects Rectification In Progress</div>
    <div class="zero_defect">No Data !</div>
  </div>
</template>

<script>
import axios from 'axios'
import echarts from 'echarts'

export default {
  props: ['project_id'],
  name: "defects",
  data() {
    return {
      my_project_id: this.project_id,
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "defects",
      dataNotNull: true,
      proj_dict: {
        "1404": "P00056",
        "1002": "P00034",
        "212": "P00005",
        "249": "P00018"
      }
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    //获取当前日期，格式YYYY-MM-DD
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  mounted() {
    let that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "212"
    }
    this.myChart = echarts.init(document.querySelector('.defectDiv .container1'))
    this.myChart.setOption({
      title: {
        text: "Defects Rectification In Progress ",
        textStyle: {
          color: '#FFF',
          fontSize: 16
        }
      },

      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      legend: {
        orient: 'vertical',
        x: 'right',
        left: '45%',
        top: 'middle',
        itemGap: 18,
        itemHeight: '8',
        textStyle: {
          color: '#FFF',
          fontSize: '10'
        },
        data: []
      },
      series: [{
        name: 'Defect',
        data: [],
        type: 'pie',
        hoverOffset: 5,
        radius: ['35%', '55%'],
        center: ['20%', '50%'],
        label: {
          normal: {
            show: true,
            position: 'inside',
            formatter: function (params) {
              if (params.value > 0) {
                return params.value
              } else {
                return ''
              }
            }
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '15',
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },

        itemStyle: {
          normal: {
            color: function (params) {
              return that.color[params.dataIndex]
            }
          },
          //鼠标悬停时：
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            borderWidth: 1
          }
        }
      }],
    })
    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });
    // this.init()
    var proj_id = ''
    if (this.proj_dict[this.my_project_id]) {
      proj_id = this.proj_dict[this.my_project_id]
    } else {
      proj_id = this.my_project_id
    }
    let postData = {
      proj_id: proj_id,
      start_date: this.getNowFormatDate(),
      end_date: this.getNowFormatDate(),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getDevServer + "DBProjDefect", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var legends = []
        var defects = []
        var result = resp.data.result;
        for (var i in result) {
          legends.push(result[i].type_name)
          defects.push({name: result[i].type_name, value: result[i].count})
        }
        this.myChart.setOption({
          legend: {
            data: legends,
            itemGap: 6,
          },
          series: [{
            data: defects
          }]
        })
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.myChart.hideLoading()
      this.dataNotNull = false
    })
  }
}

</script>

<style lang="stylus" rel="stylesheet/stylus">
.title_defect
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.zero_defect
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>



// WEBPACK FOOTER //
// src/components/quality/defect.vue